(function ($) {
    let regions;
    let producers;
    let selectedCountryID = 12;
    var selectedRegionID;
    
    $(window).load(function(){

        regions = $('.producers-filters-container').data('regions');
        producers = $('.producers-filters-container').data('producers');
        Object.keys(regions).forEach(key => {
            regions[key].children.forEach(reg => {
                $(`.producers-map-container .map #${reg.slug}`).addClass('has-producer');
            })
        })

        toggleNavAndMapCountry('france');
        populateRegionSelect(12);
        populateProducersSelect(12);
    });

    const setDefaultText = () => {
        $('#producer-ajax-container').html(`
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h3 class="my-5 text-center">Select a producer to learn more.</h3>
                    </div>
                </div>
            </div>`
        )
    }
    
    const ajaxCall = (id) => {
		$.ajax({
			url : '/wp-admin/admin-ajax.php',
            data: {
                action: 'get_producer_post',
                post_id: id
            },
			type : 'POST',
            success: function (res) {
                $('#producer-ajax-container').empty();
                if (res !== '') {
                    $('#producer-ajax-container').html(res);
                    $('html, body').animate({
                        scrollTop: $("#producer-ajax-container").offset().top
                    }, 500);
                } 
                return res;
			}
		});
    }

    const toggleMapCountry = (country) => {
        $(`.producers-map-container .svgs .active`).addClass('not-active').removeClass('active');
        $(`.producers-map-container .svgs .${country}`).addClass('active').removeClass('not-active');
    }

    const toggleNavCountry = (country) => {
        $(`.producer-svg-container .active`).removeClass('active');
        $(`.producer-svg-container #${country}`).parent('.country-container').addClass('active');
    }

    const highlightRegion = (regions) => {
        $(`.producers-map-container .map .active`).removeClass('active');
        if (typeof regions === 'string') regions = regions.split(',')
        regions.forEach(region => {
            $(`.producers-map-container .map #${region}`).addClass('active');
        })
    }
   
    const toggleNavAndMapCountry = (country) => {
        toggleNavCountry(country);
        toggleMapCountry(country);
    }

    const populateRegionSelect = (id) => {
        $('#region').empty();
        $('#region').append(`<option selected disabled>Select a Region</option>`);
        if (regions[id] && regions[id].children.length) {     
            regions[id].children.forEach(region => {
                $('#region').append(`<option id="${region.term_id}" value="${region.slug}">${region.name}</option>`);
            });
        } else {
            $('#region').append(`<option id="null" value="null">No Regions to display</option>`);
        }
    }

    const populateProducersSelect = (countryID, regionID) => {
        $('#producer').empty();
        $('#producer').append(`<option selected disabled>Select a Producer</option>`);

        let selectOptions = producers.filter(producer => producer.country_id == countryID);

        if (selectOptions.length) {     
            selectOptions.forEach(producer => {
                regionID = regionID ? parseInt(regionID) : ''
                if (regionID && producer.region_ids.includes(regionID)) {
                    $('#producer').append(`<option id="${producer.id}" value="${producer.region_slugs}">${producer.name}</option>`);
                } else if (!regionID) {
                    $('#producer').append(`<option id="${producer.id}" value="${producer.region_slugs}">${producer.name}</option>`);
                }
            });
        } else {
            $('#producer').append(`<option id="null" value="null">No Producers to display</option>`);
        }
    }

    const toggleListItemsByCountry = () => {
        $('.producers-list .producer-container').each(function () {
            let countryId = $(this).data('countryid');

            if (countryId == selectedCountryID) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        })
    }

    const toggleListItemsByRegion = () => {
        $('.producers-list .producer-container').each(function () {
            let regionIds = $(this).data('regionids');
                selectedRegionID = selectedRegionID ? parseInt(selectedRegionID) : ''
            if (regionIds && regionIds.includes(selectedRegionID)) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }

        })
    }

    const toggleListItemsByProducer = (selectedProducerID) => {
        $('.producers-list .producer-container').each(function () {
            let producerId = $(this).attr('id');

            if (producerId == selectedProducerID) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }

        })
    }

    // Filters
    $('#country').on('change', function () {
        var selectedCountrySlug = $(this).children("option:selected").val();
        selectedCountryID = $(this).children("option:selected").attr('id');
        toggleNavAndMapCountry(selectedCountrySlug);
        populateRegionSelect(selectedCountryID);
        populateProducersSelect(selectedCountryID);
        toggleListItemsByCountry()
    })

    $('#region').on('change', function () {
        var selectedRegionSlug = $(this).children("option:selected").val();
        selectedRegionID = $(this).children("option:selected").attr('id');
        highlightRegion(selectedRegionSlug);
        populateProducersSelect(selectedCountryID, selectedRegionID);
        toggleListItemsByRegion()
    })

    $('#producer').on('change', function () {
        var selectedRegionSlug = $(this).children("option:selected").val();
        selectedProducerID = $(this).children("option:selected").attr('id');
        highlightRegion(selectedRegionSlug);
        toggleListItemsByProducer(selectedProducerID)
    })

    $('.country-container div').on('click', function () {
        let selectedCountrySlug = $(this).attr('id');
        toggleNavAndMapCountry(selectedCountrySlug);
        $('#country').val(selectedCountrySlug);
        $('#country').change();
        setDefaultText()
    })

    $(document).on('click', '.producers-map-container path.has-producer', function () {
        let selectedRegionSlug = $(this).attr('id');
        $('#region').val(selectedRegionSlug);
        $('#region').change();
    })

    $('.producer-container').on('click', function () {
        let selectedRegionSlugs = $(this).data('regionslugs');
        let postId = $(this).attr('id')
        console.log('selectedRegionSlugs',selectedRegionSlugs)
        highlightRegion(selectedRegionSlugs);
        if (postId) ajaxCall(postId);
    })

    $(document).on('change', () => {
        $('.producers-map-container .svgs .active svg path').each(function(i, e) {
            let title = $(this).attr('id')
        })
    })
  
})(jQuery);
  